<template>
    <div class="campaign-box">
        <div class="campaign-option--title">Schedule</div>

        <ad-set-schedule
            v-if="showAdSetSchedule"
            v-model="element.schedule_day_ranges"
            @hasOverlaps="(hasOverlaps) => $emit('scheduleHasOverlaps', hasOverlaps)"
            class="m-t-lg"></ad-set-schedule>
        <label v-show="showErrors && !validation.schedule_day_ranges" class="error" v-cloak>All time slot fields are required.</label>
        <div v-if="showAdSetSchedule && featureFlag('ad-set-schedule-timezone')" class="row">
            <div class="col-md-4" dusk="schedule-timezone">
                <div class="campaign-option">
                    <div class="campaign-option--subtitle">
                        Timezone
                        <info-tooltip text="Timezone selected sets the schedule for the geo location searched on the rate table."></info-tooltip>
                    </div>
                    <multiselect v-model="timezone"
                                 :options="timezones"
                                 label="region"
                                 track-by="timezone"
                                 :multiple="false"
                                 :searchable="false"
                                 :show-labels="false"
                                 :allow-empty="false"
                                 :placeholder="'Select One'"
                                 data-test="ad-set-timezone-type"
                    >
                    </multiselect>
                    <div class="clearfix"></div>
                    <label v-show="showErrors && !validation.schedule_timezone" class="error" v-cloak>The Timezone field is required.</label>
                </div>
            </div>
        </div>
        <div class="row campaign-adset--budget-dates" v-if="showDates">
            <div class="col-md-4" dusk="start-date">
                <div class="campaign-option">
                    <div class="campaign-option--subtitle">
                        Start Date
                        <info-tooltip text="Your ad set will activate at 12:00 AM ET on the day selected."></info-tooltip>
                    </div>
                    <date-picker :date="dateStart" :option="dateOptions"></date-picker>
                    <a v-show="element.start_date" v-on:click.prevent="removeStartDate" class="remove"><i class="fa fa-close"></i></a>
                </div>
            </div>
            <div class="col-md-4" dusk="end-date">
                <a v-on:click.prevent="showEndDate = true" v-if="!dateEnd.time && !showEndDate" class="campaign-adset--budget-dates--end-date">
                    End Date
                </a>
                <div class="campaign-option" v-show="dateEnd.time || showEndDate">
                    <div class="campaign-option--subtitle">
                        End Date
                        <info-tooltip text="You have to option to specify a date for this ad set to end or leave it open ended if no date is specified."></info-tooltip>
                    </div>
                    <date-picker :date="dateEnd" :option="dateOptions"></date-picker>
                    <a v-on:click.prevent="removeEndDate" class="remove"><i class="fa fa-close"></i></a>
                    <label v-show="!validation.budget_end_not_after_start" class="error" v-cloak>The end date must be after the start date.</label>
                </div>
            </div>
        </div>
    </div>
</template>

<script type="text/babel">
    import DatePicker from 'vue-datepicker';
    import AdSetSchedule from './ad-set-schedule/ad-set-schedule';
    import Multiselect from 'vue-multiselect';
    import find from "lodash/find";
    import get from "lodash/get";

    const timezones = [
        {
            region:   'Eastern',
            timezone: 'America/New_York',
        },
        {
            region:   'Central',
            timezone: 'America/Chicago',
        },
        {
            region:   'Mountain',
            timezone: 'America/Denver',
        },
        {
            region:   'Pacific',
            timezone: 'America/Tijuana',
        },
        {
            region:   'Alaska',
            timezone: 'America/Anchorage',
        },
        {
            region:   'Hawaii',
            timezone: 'Pacific/Honolulu',
        },
    ];

    export default {
        props: [
            'value',
            'validation',
            'showErrors',
            'showAdSetSchedule',
            'showDates',
        ],

        data() {
            return {
                element:     this.value,
                dateStart:   {
                    time: this.value.start_date
                },
                dateEnd:     {
                    time: this.value.end_date
                },
                showEndDate: false,
                dateOptions: {
                    type:           'day',
                    week:           ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
                    month:          ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
                    format:         'MM/DD/YYYY',
                    placeholder:    'Click Here',
                    buttons:        {
                        ok:     'Ok',
                        cancel: 'Cancel'
                    },
                    overlayOpacity: 0.5, // 0.5 as default
                    dismissible:    true // as true as default
                },
                timezone:    find(timezones, { timezone: this.value.schedule_timezone }),
                timezones,
            };
        },

        watch: {
            value(val) {
                this.element = val;
                this.dateStart.time = val.start_date;
                this.dateEnd.time = val.end_date;
            },

            'dateStart.time': function() {
                this.element.start_date = this.dateStart.time;
                this.$emit('input', this.element);
            },

            'dateEnd.time': function() {
                this.element.end_date = this.dateEnd.time;
                this.$emit('input', this.element);
            },

            timezone(val) {
                this.element.schedule_timezone = get(val, 'timezone');
            },
        },

        methods: {
            removeStartDate() {
                this.dateStart.time = '';
            },

            removeEndDate() {
                this.dateEnd.time = '';
                this.showEndDate = false;
            }
        },

        components: {
            AdSetSchedule,
            DatePicker,
            Multiselect
        }
    };
</script>
